<template>

  <div class="row">
    <div class="col-md-3">
      <b-img center
        rounded="circle"
        class="banner-img"
        :src="bannerUrl">
      </b-img>
    </div>
    <div class="col-md-6">
      <section class="hero is-medium is-bold">
        <div class="hero-body">
          <div class="has-text-centered">
            <h1 class="title is-spaced">
              {{ title }}
            </h1>
            <div class="container">
              <p class="detail">
                {{ detail }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="col-md-3">
      <b-button style="float: right;" variant="primary">
        <b-link to="enroll" class="enroll-button">
          Registrar mi emprendimiento
        </b-link>
      </b-button>
    </div>
  </div>

</template>

<script>

export default {
  name: 'SimpleHeader',
  props: {
    title: String,
    detail: String,
  },
  components: {
  },
  data: function () {
    return {
      bannerUrl: "https://res.cloudinary.com/dbl4yeqf9/image/upload/v1596156183/logos/community_y1vacu.jpg"
    };
  },
}
</script>

<style scoped>
.hr {
  background-color: #E6CE9E;
  margin: 0;
  height: 5px;
}
.enroll-button {
  color: white;
  font-size: 20px;
}
.banner-img{
  object-fit: cover;
  max-height: 250px;
  width: 250px;
}
.title {
  text-align: center;
}
.detail {
  text-align: center;
}
</style>

